import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "results",
    "form",
    "tmdbId",
    "mediaType",
    "title",
    "year",
    "posterPath",
    "overview",
  ];
  static values = { url: String };

  connect() {
    this.timeout = null;
  }

  search() {
    clearTimeout(this.timeout);

    const query = this.inputTarget.value.trim();

    if (query.length < 2) {
      this.hideResults();
      return;
    }

    this.timeout = setTimeout(() => {
      this.fetchResults(query);
    }, 300);
  }

  async fetchResults(query) {
    const url = `${this.urlValue}?q=${encodeURIComponent(query)}`;

    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
      },
    });

    if (response.ok) {
      const results = await response.json();
      this.displayResults(results);
    }
  }

  displayResults(results) {
    if (results.length === 0) {
      this.resultsTarget.innerHTML =
        '<div class="p-3 text-muted">No results found</div>';
      this.showResults();
      return;
    }

    const html = results
      .map(
        (result) => `
      <div class="p-2 d-flex align-items-center search-result" style="cursor: pointer;"
           data-action="click->search#select"
           data-tmdb-id="${result.tmdb_id}"
           data-media-type="${result.media_type}"
           data-title="${this.escapeHtml(result.title)}"
           data-year="${result.year || ""}"
           data-poster-path="${result.poster_path || ""}"
           data-overview="${this.escapeHtml(result.overview || "")}">
        ${
          result.poster_path
            ? `<img src="https://image.tmdb.org/t/p/w92${result.poster_path}" class="me-2 rounded" style="width: 40px; height: 60px; object-fit: cover;">`
            : `<div class="me-2 bg-secondary rounded d-flex align-items-center justify-content-center" style="width: 40px; height: 60px;"><i class="bi bi-film text-white"></i></div>`
        }
        <div>
          <div class="fw-bold">${this.escapeHtml(result.title)} ${result.year ? `<small class="text-muted">(${result.year})</small>` : ""}</div>
          <small class="badge bg-${result.media_type === "movie" ? "primary" : "info"}">${result.media_type === "movie" ? "Movie" : "TV"}</small>
        </div>
      </div>
    `
      )
      .join("");

    this.resultsTarget.innerHTML = html;
    this.showResults();
  }

  select(event) {
    const target = event.currentTarget;

    this.tmdbIdTarget.value = target.dataset.tmdbId;
    this.mediaTypeTarget.value = target.dataset.mediaType;
    this.titleTarget.value = target.dataset.title;
    this.yearTarget.value = target.dataset.year;
    this.posterPathTarget.value = target.dataset.posterPath;
    this.overviewTarget.value = target.dataset.overview;

    this.formTarget.requestSubmit();

    this.inputTarget.value = "";
    this.hideResults();
  }

  showResults() {
    this.resultsTarget.style.display = "block";
  }

  hideResults() {
    this.resultsTarget.style.display = "none";
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
